import ArticleListSkeleton from './ArticleListSkeleton';

interface ArticlesSectionSkeletonProps {
  readonly showGrid?: boolean;
  readonly hideCoverImages?: boolean;
}
export default function ArticlesSectionSkeleton({
  showGrid = false,
  hideCoverImages = false,
}: ArticlesSectionSkeletonProps) {
  return (
    <ArticleListSkeleton
      showGrid={showGrid}
      hideCoverImages={hideCoverImages}
    />
  );
}
